export default ({ route, redirect, app }) => {
  if (process.client) {
    app.router.beforeEach(async (to, from, next) => {
      await localStorage.setItem(
        'internal_origin',
        JSON.stringify({
          value: 'true',
          expiry: Date.now() + 10 * 60000,
        })
      )
      return next()
    })

    app.router.beforeEach(async (to, from, next) => {
      await app.store.dispatch('program/loadProgramGlobal', { promoterName: route.params.promoter, programName: route.params.program })
      next()
    })
  }
}
